module.exports = __webpack_public_path__ + "img/mesa_el_nh.04926537.png";